import { render, staticRenderFns } from "./StretchedLinkPage.vue?vue&type=template&id=3656abee&scoped=true&"
import script from "./StretchedLinkPage.vue?vue&type=script&lang=js&"
export * from "./StretchedLinkPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3656abee",
  null
  
)

export default component.exports